import store from '@/store';

const getValueByPath = (node, keyPath) => {
    return keyPath.split('.').reduce((sum, current) => sum[current], node)
}

/**
 * Get node from FAQ's tree by path to key and value
 * @param {String} keyPath path to key - e.g. 'attributes.uuid' or 'fullPath'
 * @param {String} value
 * @returns {Object} tree node
 */
export const getNode = (keyPath, value) => {
    const faqTree = store.state.FAQ.faqTree
    const isMatch = (node) => getValueByPath(node, keyPath) === value

    const findItem = node => {
        if (isMatch(node)) return node

        if (node.children && node.children.length) {
            for (let childNode of node.children) {
                const matchNode = findItem(childNode)
                if (matchNode) return matchNode
            }
        }
    }

    return findItem(faqTree)
}
